import { InstalledPlugins } from "@/features/plugins/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/plugins/")({
	component: InstalledPluginsPage,
});

function InstalledPluginsPage() {
	return <InstalledPlugins />;
}
